export default "__VITE_ASSET__8ef23d46__"